<script>
    import { _ } from "../services/i18n";
    import HeaderHome from "../components/HeaderHome.svelte";
    import ImageUploadDialog from "../components/ImageUploadDialog.svelte";
    import Grid from "../components/Grid.svelte";

    import { getImages, getImageUrl } from "../services/images";
    import { search } from "../services/filters";

    import { onMount } from "svelte";

    let images = [];
    let filterImages = [];

    // bind a la función showUploadDialog de ImageUploadDialog
    let showUploadDialog;

    // Manejador del evento on:imageUpdated de ImageUploadDialog
    const onImageUpdated = async (imgData) => {
        images = await getImages();
        filterImages = images;
    }
    
    let textChangedTimer = null;
    const searchTextChange = (evt) => {
        const searchText = evt.target.value;
        if (textChangedTimer) {
            clearTimeout(textChangedTimer);
        }
        textChangedTimer = setTimeout(() => {
            filterImages = search(searchText, images, ['name','metadata']);
        }, 250);
    }

    onMount(async () => {
        images = await getImages();
        filterImages = images;
    });

    const editImage = (image) => {
        showUploadDialog(image);
    }
</script>

<main>
    <HeaderHome />
    <header>
        <h3>{$_("images_welcome")}</h3>
    </header>

    <ImageUploadDialog bind:show={showUploadDialog} on:imageUpdated={onImageUpdated} maxSize=300/>

    <Grid items={filterImages}>
        <span slot="header">
            <button on:click={() => showUploadDialog()}>{$_("images_uploadNew")}</button>
            <input type="search" placeholder="Buscar imágenes" on:keyup={searchTextChange} on:change={searchTextChange} on:input={searchTextChange}/>
        </span>
        <li slot="listItem" let:item on:click={() => editImage(item)} on:keydown={() => editImage(item)}>
            <strong>{item.name}</strong>
            <img src={getImageUrl(item)} alt={item.name} loading="lazy"/>
        </li>
    </Grid>
</main>

<style>
    main {
        width: 90%;
        margin-left: auto;
        margin-right: auto;
    }
</style>

<svelte:head>
    <link rel="stylesheet" href="styles/ui/grid.css" />
</svelte:head>